import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import FadeInSection from '@/components/base/FadeInSection';
import ContactSection from '@/pages/home/components/ContactSection';
import LocationSection from '@/pages/home/components/LocationSection';

export default function Contact() {
  return (
    <main>
      <Navbar />
      <div className="pt-14">
        <FadeInSection>
          <LocationSection />
        </FadeInSection>
        <FadeInSection>
          <ContactSection />
        </FadeInSection>
      </div>
      <Footer />
    </main>
  );
}